import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { Player } from 'modules/players/domain/interfaces/player';
import { ListPlayersArgs, useListPlayersQuery } from 'modules/players/store/players-api';
import { useSelector } from 'react-redux';
import { useOffsetPagination } from 'shared/hooks/use-offset-pagination';

const filtersConfig = {
  nameFilter: { key: 'nameFilter', defaultValue: '' as string },
};

/**
 * Список игроков организации на RTK Query. Лежал в `modules/tests/domain/hooks`,
 * хотя это домен игроков (и `domain/` — не место для хука).
 *
 * Страница `/players` пока читает список старым thunk-ом: у неё ручной кэш с
 * догрузкой по `offset` и `invalidatePlayersList`, перевод на RTK Query — отдельная
 * задача. Этот хук используется на `/tests/players`.
 */
export function usePlayersList() {
  const tournamentId = useSelector(authStoreUserTournamentId);

  return useOffsetPagination<Player, ListPlayersArgs, typeof filtersConfig>({
    useQueryHook: useListPlayersQuery,
    baseArgs: { tournamentId: Number(tournamentId) },
    mapFiltersToArgs: (f) => ({
      nameFilter: f.nameFilter || undefined,
    }),
    filtersConfig,
    perPageStorageKey: 'playersPerPage',
    defaultPerPage: 10,
    queryOptions: () => ({ skip: !tournamentId }),
  });
}
